export const _setAttendanceFilterOptions = (state, action) => action.payload;
